import { JsonParser } from '@1inch-community/core/storage';
import { getChainIdList } from '@1inch-community/sdk/chain';
import { BehaviorSubject, defer, Subject } from 'rxjs';
export class SelectTokenContext {
    constructor(tokenType, applicationContext, swapContext) {
        this.tokenType = tokenType;
        this.applicationContext = applicationContext;
        this.swapContext = swapContext;
        this.chainId$ = defer(() => this.applicationContext.wallet.data.chainId$);
        this.connectedWalletAddress$ = defer(() => this.applicationContext.wallet.data.activeAddress$);
        this.tokenListFlatView$ = new BehaviorSubject(false);
        this.searchToken$ = new BehaviorSubject('');
        this.changeFavoriteTokenState$ = new Subject();
        this.searchInProgress$ = new BehaviorSubject(false);
        this.openCrossChainView$ = new BehaviorSubject(['', false]);
        this.chainFilter$ = new BehaviorSubject([]);
        const chainFilter = this.applicationContext.storage.get('inch-select-token_chain-filter', JsonParser) ?? getChainIdList();
        const tokenListFlatView = this.applicationContext.storage.get('inch-select-token_flat-list', JsonParser) ??
            false;
        this.chainFilter$.next(chainFilter);
        this.tokenListFlatView$.next(tokenListFlatView);
    }
    tokenListFlatViewToggle() {
        this.tokenListFlatView$.next(!this.tokenListFlatView$.value);
        this.applicationContext.storage.set('inch-select-token_flat-list', this.tokenListFlatView$.value);
    }
    setSearchState(state) {
        this.searchInProgress$.next(state);
    }
    setSearchToken(state) {
        this.searchToken$.next(state);
    }
    getSearchTokenValue() {
        return this.searchToken$.value;
    }
    onSelectToken(token) {
        this.swapContext.setToken(this.tokenType, token);
    }
    onChangeChainFilter(chainIdList) {
        this.chainFilter$.next(chainIdList);
        this.applicationContext.storage.set('inch-select-token_chain-filter', chainIdList);
    }
    getOpenCrossChainView() {
        return this.openCrossChainView$.value;
    }
    onOpenCrossChainView(symbol, openMore) {
        this.openCrossChainView$.next([symbol, openMore]);
    }
}
//# sourceMappingURL=select-token.context.js.map